import { postApiCall} from "../utils/Api";

export const ListPurchase = async (data) => {
    try {
      const result = await postApiCall(`/api/v1/dashboard/getpurchasesummary`,data,true);
      var apiresult = JSON.parse(result.data.message);
      //console.log(apiresult)
      return apiresult;
    } catch (e) {
      throw e;
    }
  };